import { buildHomepageAnchorHref } from '@web-studio/shared-schemas';
import { EditableContent } from '../../edit/EditableContent';
import { pickBlockField } from '../../lib/localized';
import type { BlockRenderProps } from '../../types';

export function VipTableBookingStrip({
  block,
  locale,
  defaultLocale = locale,
  publicPathPrefix,
  isActive,
  activeEditTarget,
  editable,
}: BlockRenderProps) {
  const heading = pickBlockField(block.content, 'heading', locale);
  const supporting = pickBlockField(block.content, 'supporting', locale);
  const capacityNote = pickBlockField(block.content, 'capacityNote', locale);
  const ctaLabel = pickBlockField(block.content, 'ctaLabel', locale);
  const partyHref = buildHomepageAnchorHref('#party', locale, defaultLocale, publicPathPrefix);
  const target = isActive ? activeEditTarget : null;

  return (
    <section
      className={['ws-vip-strip', isActive ? 'ws-block--active' : ''].filter(Boolean).join(' ')}
      data-block-id={block.blockId}
      data-component={block.componentType}
      id="vip"
    >
      <div className="ws-vip-strip__inner">
        <div className="ws-vip-strip__copy">
          <EditableContent
            as="h2"
            fieldKey="heading"
            editable={editable}
            activeEditTarget={target}
            className="ws-vip-strip__title"
          >
            {heading}
          </EditableContent>
          <EditableContent
            fieldKey="supporting"
            editable={editable}
            activeEditTarget={target}
            className="ws-vip-strip__supporting"
          >
            {supporting}
          </EditableContent>
          {capacityNote || editable ? (
            <EditableContent
              fieldKey="capacityNote"
              editable={editable}
              activeEditTarget={target}
              className="ws-vip-strip__capacity"
            >
              {capacityNote}
            </EditableContent>
          ) : null}
        </div>
        {ctaLabel ? (
          <EditableContent
            as="a"
            fieldKey="ctaLabel"
            editable={editable}
            activeEditTarget={target}
            className="ws-vip-strip__cta"
            href={partyHref}
          >
            {ctaLabel}
          </EditableContent>
        ) : null}
      </div>
    </section>
  );
}
